var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-col', {
    attrs: {
      "cols": _vm.cols
    }
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "transition": "scroll-x-transition",
      "offset-x": "",
      "max-width": "290px",
      "min-width": "auto"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-sheet', _vm._g(_vm._b({
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "elevation": "3",
            "height": 25,
            "width": 25
          }
        }, 'v-sheet', attrs, false), on))];
      }
    }]),
    model: {
      value: _vm.menu,
      callback: function ($$v) {
        _vm.menu = $$v;
      },
      expression: "menu"
    }
  }, [_c('v-color-picker', {
    attrs: {
      "mode": _vm.mode,
      "hide-mode-switch": "",
      "disabled": _vm.disabled
    },
    on: {
      "input": _vm.updateColor
    },
    model: {
      value: _vm.color,
      callback: function ($$v) {
        _vm.color = $$v;
      },
      expression: "color"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }